import type { ClientInvoiceItemDto } from '../../lib/clientInvoiceApi';

/**
 * The case conversion a line shows in its panel, as words the server already wrote ("CASE of 12 x 300 ML", "CS of 24"):
 *  - `current`: the confirmed bill's pack while the cost stands on a bill, else the PO's pack. Null when no document
 *    states one: a pack nobody stated is not shown, and never a pack of one.
 *  - `before`: the PO's pack, only while a bill states a DIFFERENT count (both counts known and unequal), so the screen
 *    strikes the old pack through beside the new one. The same pack, or a count missing on either side, shows no change.
 * Display only: nothing computes from either.
 */
export function caseConversionOf(
  item: Pick<ClientInvoiceItemDto, 'costBasis' | 'poPackCount' | 'poPackText' | 'billedPackCount' | 'billedPackText'>
): { current: string | null; before: string | null } {
  const text = (value?: string | null) => (value && value.trim() ? value.trim() : null);
  const billed = item.costBasis === 'billed' ? text(item.billedPackText) : null;
  const po = text(item.poPackText);
  const current = billed ?? po;
  const differs =
    !!billed && !!po &&
    typeof item.billedPackCount === 'number' && typeof item.poPackCount === 'number' &&
    item.billedPackCount !== item.poPackCount;
  return { current, before: differs ? po : null };
}
